import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { PrefijoComponent } from './Prefijo.component';
import { PrefijoIndexComponent } from './PrefijoIndex.component';
import { ConfirmarDelete } from './PrefijoIndex.component';


import { MandanteIndexComponent } from './MandanteIndex.component';
import { MandanteFormComponent } from './MandanteForm.component';
import { DialogConfirmacion } from './MandanteIndex.component';
import { MandanteNewComponent } from './MandanteNew.component';


import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';



const routes = [
    {
        path     : 'Prefijo',
        component: PrefijoIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Prefijo',
          nombreFormulario : 'Prefijos'
        } 
    },
    {
        path     : 'Prefijo/:cnumcont',
        component: PrefijoIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Prefijo',
          nombreFormulario : 'Crear Prefijo'
        } 
    },
    {
        path     : 'Prefijo/:cnumcont/:cprefijo',
        component: PrefijoComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Prefijo',
          nombreFormulario : 'Editar Prefijo'
        } 
    },
    {
        path     : 'Prefijo/:cnumcont/:d/:desdeContrato',
        component: PrefijoIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Prefijo',
          nombreFormulario : 'Prefijos'

        } 
    },
    {
        path 	 : 'Mandante',
        component: MandanteIndexComponent,
            canActivate: [RoleGuard], 
            data: { 
              formulario: 'Prefijo',
              nombreFormulario : 'Mandantes'
            } 
    },
    {
        path      : 'Mandante/:atras/:cnumcont',
        component: MandanteIndexComponent,
            canActivate: [RoleGuard], 
            data: { 
              formulario: 'Prefijo',
              nombreFormulario : 'Mandantes'
            } 
    },
    
    {
    
        path      : 'Mandante/:atras/:cnumcont/:cprefijo',
        component: MandanteIndexComponent,
            canActivate: [RoleGuard], 
            data: { 
              formulario: 'Prefijo',
              nombreFormulario : 'Mandantes'
            } 
    },
    {
        path      : 'Mandante/:atras/:cnumcont/:cnumid/:editar',
        component: MandanteFormComponent,
            canActivate: [RoleGuard], 
            data: { 
              formulario: 'Prefijo',
              nombreFormulario : 'Crear Mandante'
            } 
    },
    {
        path      : 'Mandante/:atras/:cnumcont/:cnumid/:editar/:prefijo',
        component: MandanteFormComponent,
            canActivate: [RoleGuard], 
            data: { 
              formulario: 'Prefijo',
              nombreFormulario : 'Editar Mandante'
            } 
    }
];

@NgModule({
    declarations: [
        PrefijoComponent,
        PrefijoIndexComponent,
        ConfirmarDelete,

        MandanteIndexComponent,
        MandanteFormComponent,
        MandanteNewComponent,
        DialogConfirmacion
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        PrefijoComponent,
        PrefijoIndexComponent,
        ConfirmarDelete,

        MandanteIndexComponent,
        MandanteFormComponent,
        MandanteNewComponent
    ],
  
})

export class PrefijoModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Prefijo/Prefijo.module.ts